export default __webpack_public_path__ + "static/media/imgelution.f5591443.png";